import { Timers } from "@tldraw/utils";
const tltime = new Timers();
export {
  tltime
};
//# sourceMappingURL=time.mjs.map
